import script from "./InstagramUser.vue?vue&type=script&lang=ts&setup=true"
export * from "./InstagramUser.vue?vue&type=script&lang=ts&setup=true"

import "./InstagramUser.vue?vue&type=style&index=0&id=62941442&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62941442"]])

export default __exports__